import type { ScheduleTargetType } from '@/types/api'

/** `/schedules` search params: `?schedule=<id>` opens the editor (deep link from calendar / conflicts). */
export interface SchedulesSearch {
  schedule?: string
  target_type?: ScheduleTargetType
  target_id?: string
}

const TYPES = new Set<string>(['tenant', 'location', 'display_group', 'tag', 'display'])
const str = (v: unknown): string | undefined => (typeof v === 'string' && v.length > 0 ? v : undefined)

export function validateSchedulesSearch(s: Record<string, unknown>): SchedulesSearch {
  const type = typeof s.target_type === 'string' && TYPES.has(s.target_type) ? (s.target_type as ScheduleTargetType) : undefined
  return { schedule: str(s.schedule), target_type: type, target_id: type && type !== 'tenant' ? str(s.target_id) : undefined }
}
